import React from 'react';
import { useKpros } from '../../context/KprosContext';
import { useTheme } from '../../context/ThemeContext';
import { X, Lightbulb, MessageCircle, Flag } from 'lucide-react';
import KprosTipsFeed from './KprosTipsFeed';
import KprosChat from './KprosChat';
import KprosReportForm from './KprosReportForm';
import { Hop } from 'lucide-react';

const TABS = [
  { key: 'tips', label: 'Tips', icon: Lightbulb },
  { key: 'ask', label: 'Ask', icon: MessageCircle },
  { key: 'report', label: 'Feedback', icon: Flag },
];

export default function KprosPanel() {
  const { panelOpen, setPanelOpen, activeTab, setActiveTab } = useKpros();
  const { theme } = useTheme();

  if (!panelOpen) return null;

  return (
    <>
      {/* Backdrop for mobile */}
      <div
        className="fixed inset-0 bg-black/20 z-[60] md:hidden"
        onClick={() => setPanelOpen(false)}
      />

      {/* Panel */}
      <div className={`fixed right-0 top-0 h-full w-[90%] sm:w-[400px] z-[61] flex flex-col shadow-2xl transition-transform duration-300 ${
        theme === 'dark' ? 'bg-gray-800 text-white border-l border-gray-700' : 'bg-white text-gray-900 border-l border-gray-200'
      }`} style={{ fontFamily: 'Rasa, serif' }}>
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 rounded-lg flex items-center justify-center">
              <span className="text-gray-800 dark:text-gray-200 text-xs font-bold"><Hop/></span>
            </div>
            <h2 className="text-base font-semibold" style={{ fontFamily: 'Unna, serif' }}>Kpros</h2>
          </div>
          <button
            onClick={() => setPanelOpen(false)}
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        {/* Tab bar */}
        <div className="flex border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`flex-1 flex items-center justify-center gap-1.5 py-2.5 text-xs font-medium transition-colors ${
                activeTab === tab.key
                  ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-500'
                  : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
              }`}
            >
              <tab.icon size={14} />
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="flex-1 overflow-hidden">
          {activeTab === 'tips' && <KprosTipsFeed />}
          {activeTab === 'ask' && <KprosChat />}
          {activeTab === 'report' && <KprosReportForm />}
        </div>
      </div>
    </>
  );
}
